import {Component, OnInit} from '@angular/core';
import {ListComponent, ItemComponent} from 'app/commons/list.component';
import {AppComponent} from 'app/app.component';
import {ConfirmationService, MessageService} from 'primeng/api';
import {FormsService} from './form.service';
import {Router, ActivatedRoute} from '@angular/router';
import {AppBreadcrumbService} from '../app.breadcrumb.service';
import {LoginService} from '../login/login.service';

@Component({
    selector: 'afm-forms',
    templateUrl: '../commons/items.component.html',
    styleUrls: ['../commons/items.component.scss']
})
export class FormsComponent implements OnInit {

    title : string = 'Forms Management'
    
    constructor() {}

    ngOnInit() {
    }

}

@Component({
    templateUrl: '../commons/list.component.html',
    styleUrls: ['../commons/items.component.scss']
})
export class FormListComponent extends ListComponent implements OnInit {

    constructor(private cs: ConfirmationService, private ms: MessageService,private s: FormsService, private a: AppComponent, public bs: AppBreadcrumbService) {
        super(cs,ms,s,a,bs);
        this.canAdd = false;
        this.canRemove = false;
    }

    ngOnInit() {
        super.ngOnInit()
        this.title = 'List of forms';
        
    }
    getPath(){
        return 'form';
    }

    getCols(){
        return [
            { field: 'id', header: 'ID' ,placeHolder:'' ,width : '60px' },
            { field: 'name', header: 'Name',placeHolder:'' },
            { field: 'alias', header: 'Alias',placeHolder:'' },
            { field: 'version', header: 'Version',placeHolder:'' },
            { field: 'processId.name', header: 'Process' ,placeHolder:''}
        ];
    }
}
@Component({
    templateUrl: './form.component.html',
    styleUrls: ['../commons/items.component.scss']
})
export class FormComponent extends ItemComponent implements OnInit {
    
    
    roles : any[] = [];

    constructor(private ms: MessageService, private s: FormsService,
        private a: AppComponent, private rt: Router, private r: ActivatedRoute,public bs: AppBreadcrumbService,public loginService:LoginService) {
        super(ms,s,a,rt,r,bs);
    }

    ngOnInit() {
        super.ngOnInit()
        this.item = {"partnerId":{}};
        this.s.getRoles().then(data => this.roles = data);
    }
    
    getPath(){
        return 'forms';
    }
    getSuccessMessage(){
        return 'Form save with success';
    }
    getSelectedGroups(items : any[]) : any[]{
        var user = this.loginService.getLoggedUser();
        return items.filter(item =>  item.partnerId.id == user.partnerId.id);
    }

}

